import { useCallback } from 'react';
import { formatLocalDate } from '../../utils/dateUtils';
import { useBrushSelection } from './useBrushSelection';

export const DEER_SIGHTINGS_X_KEY = 'date';
export const DEER_SIGHTINGS_DATA_KEY = 'deer_seen';

export function useDeerSightingsTimelineBrush(chartData) {
  return useBrushSelection({
    data: Array.isArray(chartData) ? chartData : [],
    dataKey: DEER_SIGHTINGS_X_KEY
  });
}

export function buildDeerSightingsSeries(options = {}) {
  const { animate = true, colorIndex = 0 } = options;
  return [
    {
      name: 'Deer seen',
      dataKey: DEER_SIGHTINGS_DATA_KEY,
      isAnimationActive: animate,
      color: `var(--chart-series-${colorIndex + 1})`,
      strokeWidth: 2,
      dot: false,
      activeDot: { r: 5, strokeWidth: 2 }
    }
  ];
}

export const deerSightingsTickFormatter = (value) =>
  formatLocalDate(value, { month: 'short', day: 'numeric' }, 'en-US');

export const deerSightingsLabelFormatter = (value) =>
  formatLocalDate(value, { weekday: 'short', month: 'short', day: 'numeric' }, 'en-US');

export function formatDeerSightingsValue(value) {
  if (value == null) return '--';
  return `${Number(value)} deer`;
}

export function useDeerSightingsFormatters() {
  const tickFormatter = useCallback(deerSightingsTickFormatter, []);
  const labelFormatter = useCallback(deerSightingsLabelFormatter, []);
  const valueFormatter = useCallback(formatDeerSightingsValue, []);
  return { tickFormatter, labelFormatter, valueFormatter };
}
